/**
 * input.jsx — Styled text input primitive.
 *
 * Exports: Input
 *
 * A thin wrapper around <input> that applies consistent border, background,
 * focus ring, and disabled styles. Forwards ref and accepts all standard
 * <input> HTML attributes including type. Extra className values are merged
 * with cn() so callers can safely extend styles.
 */
import * as React from "react"
import { cn } from "../../lib/utils"

/**
 * Input — Styled form input field.
 *
 * @param {string}      [props.className] - Additional Tailwind classes.
 * @param {string}      [props.type]      - HTML input type (e.g. 'text', 'email', 'password').
 * @param {React.Ref}   ref              - Forwarded ref.
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Base styles: full width, fixed height, border, focus ring, disabled state.
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})

Input.displayName = "Input"

export { Input }
